export default "__VITE_ASSET__BYdPDN1u__"